import { MagicConfigMixin, ContentMixin, cdnService, ImageFormat, ImageFit, RoutablePage, waitForImage, scroll } from '@gig/magic-common';
import { Mixins, Vue, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { magic } from '@gig/magic-sdk';
import { OFFER_NAMESPACE } from '../../store/modules/offer/offer.store.js';
import { store } from '../../store/index.js';
import { CtaStyle } from '@gig/magic-sdk/dist/util/interfaces';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const offers = namespace(OFFER_NAMESPACE);
let OfferComponent = class extends Mixins(MagicConfigMixin, ContentMixin) {
  get offer() {
    return this.getOffer(this.slug, this.magicConfig.language);
  }
  get background() {
    if (!this.offer || !this.offer.background) {
      return "";
    }
    return cdnService.getOfferBackgroundUrl(this.offer.background, {
      width: 1,
      height: 1,
      format: ImageFormat.WEBP
    });
  }
  get src() {
    return this.getImage(ImageFormat.WEBP);
  }
  get avifSrcset() {
    return this.getImageSrcset(ImageFormat.AVIF);
  }
  get webpSrcset() {
    return this.getImageSrcset(ImageFormat.WEBP);
  }
  getImageSrcset(format) {
    if (!this.offer || !this.offer.image) {
      return null;
    }
    return this.widths.map((width) => `${this.getImage(format, width)} ${width}w`).join(", ");
  }
  getImage(format, width = 1) {
    if (!this.offer || !this.offer.image) {
      return null;
    }
    return cdnService.getPromotionImageUrl(this.offer.image, {
      width,
      fit: ImageFit.MAX,
      format
    });
  }
  loadOffer() {
    return __async(this, null, function* () {
      try {
        this.onContentLoadInit();
        yield this.fetchOffer({
          slug: this.slug,
          lang: this.magicConfig.language
        });
        this.onContentLoad(this.offer);
      } catch (e) {
        console.error("Offer error:", e);
        this.onContentLoadError(e);
        this.routeTo({ route: RoutablePage.NOT_FOUND });
      }
    });
  }
  onOfferLoad() {
    return __async(this, null, function* () {
      const user = magic.session.getUser();
      if (this.offer && this.offer.authRequired && !user) {
        this.routeTo({ route: RoutablePage.HOME });
        return;
      }
      yield Vue.nextTick();
      if (!this.showTerms || !this.$refs.terms) {
        return;
      }
      yield waitForImage(this.$refs.header);
      scroll.scrollTo(this.$refs.terms);
    });
  }
  onCtaClick(cta) {
    const user = magic.session.getUser();
    if (cta.style === CtaStyle.OPTIN && user) {
      magic.methods.offers.optIn(this.slug, this.magicConfig.language, cta.text, user.userName);
    }
  }
  onContentLoad(offer) {
    return offer;
  }
};
__decorateClass([
  Prop(String)
], OfferComponent.prototype, "slug", 2);
__decorateClass([
  Prop(Array)
], OfferComponent.prototype, "widths", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], OfferComponent.prototype, "showTerms", 2);
__decorateClass([
  offers.Getter("getOffer")
], OfferComponent.prototype, "getOffer", 2);
__decorateClass([
  offers.Action("fetchOffer")
], OfferComponent.prototype, "fetchOffer", 2);
__decorateClass([
  Watch("magicConfig.language"),
  Watch("slug", { immediate: true })
], OfferComponent.prototype, "loadOffer", 1);
__decorateClass([
  Watch("offer", { immediate: true })
], OfferComponent.prototype, "onOfferLoad", 1);
__decorateClass([
  Emit("contentLoad")
], OfferComponent.prototype, "onContentLoad", 1);
OfferComponent = __decorateClass([
  Component({
    name: "offer",
    store
  })
], OfferComponent);

export default OfferComponent;
